import CareerMainSection from "../PageElements/CareerPageElement/CareerMainSection";

export default function CareerPage() {
  return (
    <>
      <CareerMainSection />
    </>
  );
}
